import * as React from "react";
import { SVGProps } from "react";

const Xensor = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000" {...props}>
    <g fillRule="evenodd">
      <path
        fill="#383b4a"
        d="M500 0c276.1 0 500 223.9 500 500s-223.9 500-500 500S0 776.1 0 500 223.9 0 500 0Z"
      />
      <path
        fill="#fff"
        d="m780.3 530.5-20.4 20.4C528.1 320.1 271 448.4 209.6 484.5a44.57 44.57 0 0 1 11-18l247.8-247.8a45.21 45.21 0 0 1 64 0l247.8 247.8a45.12 45.12 0 0 1 .1 64ZM588.6 722.2l-56.1 56.1a45.21 45.21 0 0 1-64 0l-53.6-53.6c86.2-61 159.9-12.8 173.7-2.5Z"
      />
      <path
        fill="#fff"
        d="m747.3 563.5-64 64c-190.2-176.4-381-62.8-409.6-44l-14.1-14.1a1.76 1.76 0 0 0 .5-.4c249.2-199.8 466.1-23.6 487.2-5.5Z"
      />
      <path
        fill="#fff"
        d="m357.1 667-15.4-15.4c147.9-134.8 310.4-20.1 326.1-8.5l-65.4 65.4C485.3 595.8 376.7 654.7 357.1 667Z"
      />
    </g>
  </svg>
);

export default Xensor;
